import { Form } from "@repo/ui";
import { useForm } from "react-hook-form";
import FormInput from "ui/Input";

export default function LocationDetails({ location }) {
  const form = useForm({ defaultValues: { ...location } });
  const generalProps = { errors: form.formState.errors, control: form.control };
  return (
    <div className="form-container" style={{ margin: 0 }}>
      <Form {...form}>
        <form className="custom-form-v2">
          <h1 className="text-lg font-medium">Asset Details</h1>
          {/* <div className="flex flex-row justify-end w-full my-2">
            <Link>
              <Button variant={"secondary"}>Open Records</Button>
            </Link>
          </div> */}
          <div className="dialogue-form-row mt-4">
            <FormInput
              {...generalProps}
              name="locationId"
              label="Asset ID"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="barcode"
              label="Barcode"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="locationName"
              label="Location Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="emirate"
              label="Emirate"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="state"
              label="Region"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="machineType"
              label="Machine Type"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="customer"
              label="Customer"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="maker"
              label="Maker"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="address"
              label="Address"
              hideIcons
              inputProps={{ readOnly: true }}
            />
          </div>
        </form>
      </Form>
    </div>
  );
}
